import type { FormFieldData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type { VermarktungContractTemplateAdjustments } from "../Direktvermarktung.types";

export const VERMARKTUNG_CONTRACT_TEMPLATE_ADJUSTMENT_FIELDS = {
  copyId: {
    name: "copyId",
    type: "select",
    label: "Vertrag, welcher als Vorlage kopiert werden soll",
    required: true
  }
} as const satisfies FormFieldData<VermarktungContractTemplateAdjustments>;
